<div class="guided-flow-pattern" [ngClass]="{ 'guided-flow-internal': environment.internal }">
  <main>
    <div class="container">
      <app-save-status-modal></app-save-status-modal>

      <!-- Currently put this here since we're using the helpDrawer isModal implementation (can also be elsewhere in the template that renders the main content) -->
      <app-help-drawer></app-help-drawer>

      <ng-container *ngTemplateOutlet="mainContent"></ng-container>
    </div>
  </main>

  <!-- GuidedFlowZ-Index: Related comment for the scss comment in guided-flow.component.scss.
    Handling things like this because prior stylings would cause the button-container to stay on top of the modal backdrop when the modal was rendered, which would let a user click the buttons to trigger more actions -->
  <div
    class="guided-flow-pattern__floating-action-button-container"
    [ngStyle]="{
      'z-index': ['loading', 'error'].includes(globalStore.modalSyncState()) ? '0' : '1600',
    }"
  >
    <div class="container">
      <div class="guided-flow-pattern__floating-action-button-group">
        <!-- Leaving it this way for now because IF we have any guided-flow steps more than 2, we'll still need to render the buttons this way-->
        <ng-container *ngIf="currentStep > 1; else cancelButton">
          <c11n-button
            labelText="{{ constants.BUTTON_BACK }}"
            [variant]="'secondary'"
            [fullWidth]="true"
            (clickEvent)="handleBack()"
          ></c11n-button>
        </ng-container>
        <ng-template #cancelButton>
          <c11n-button
            labelText="{{ constants.BUTTON_CANCEL }}"
            [variant]="'secondary'"
            [fullWidth]="true"
            (clickEvent)="handleCancelandQuit()"
          ></c11n-button>
        </ng-template>

        <c11n-button
          id="continue-confirm-button"
          labelText="{{
            currentStep === totalSteps ? constants.BUTTON_CONFIRM : constants.BUTTON_CONTINUE
          }}"
          [fullWidth]="true"
          (clickEvent)="handleContinue()"
        ></c11n-button>
      </div>
    </div>
  </div>
</div>

<ng-template #mainContent>
  <section class="guided-flow-pattern__content__header-container">
    <c11n-button
      [size]="'small'"
      [labelText]="'Quit'"
      [variant]="'ghost'"
      [iconPosition]="'trailing'"
      (clickEvent)="handleCancelandQuit()"
      iconName="remove"
      class="guided-flow-pattern__quit-btn"
    >
    </c11n-button>
    <div class="guided-flow-pattern__content__header">
      <div class="guided-flow-pattern__content__header-main">
        <span
          class="c11n-text-xl guided-flow-pattern__content__heading"
          id="guided-flow-title"
          tabindex="-1"
          #title
        >
          {{ guidedFlowTitle() }}
        </span>
        <p class="c11n-text-md c11n-link--reinforced">
          <a
            c11n-link
            id="help-link"
            [iconName]="'help'"
            [variant]="'secondary-reinforced'"
            (click)="triggerHelpDrawer()"
            (keydown.enter)="triggerHelpDrawer(); $event.preventDefault()"
            (keydown.space)="triggerHelpDrawer(); $event.preventDefault()"
            tabindex="0"
            aria-label="Button to open information help drawer"
            >Help</a
          >
        </p>
      </div>
    </div>
  </section>

  <section class="guided-flow-pattern__content__body-container">
    <!-- WMPS-4245: This accountType should be replaced with inventoryItemType (and the other refs to it in this class) -->
    <ng-container *ngFor="let step of componentSteps[accountType]; let i = index">
      <!-- The *ngIf="currentStep === i + 1" check is used to conditionally render the template for the current step in the guided flow. This ensures that only the template corresponding to the current step is displayed, while other steps are hidden. Without this, the ngTemplateOutlet would generate multiple components, all displayed at once and not by step. -->
      <ng-container *ngIf="currentStep === i + 1">
        <ng-container *ngTemplateOutlet="getTemplateForStep(step)"></ng-container>
      </ng-container>
    </ng-container>
  </section>
  <div class="c11n-space-stack-6x c11n-space--force">
    <router-outlet #o="outlet" (activate)="handleRouteChange($event)"></router-outlet>
  </div>
</ng-template>
<!--Bind the components we want to dynamically generate with getTemplateForStep-->
<!--The steps are generated in sequential step based on GUIDED_FLOW_COMPONENT_STEPS in guided-flow-content.ts-->
<!-- WMPS-4245: the accountType should be inventoryItemType -->
<ng-template #accountOwner>
  <app-account-owner [accountType]="accountType"></app-account-owner>
</ng-template>
<ng-template #accountDetails>
  <app-account-details
    [accountType]="accountType"
    [handleBack]="handleBack.bind(this)"
    [onHelpClick]="triggerBeneficiaryHelpDrawer.bind(this)"
  ></app-account-details>
</ng-template>
<ng-template #empty></ng-template>
